namespace advisorop.components.servicer {

    export class CUExternalSystemDataMappingController {
        externalSystems: domains.IExternalSystem[] = [];
        externalSystem: domains.IExternalSystem;
        externalSystemDataMapping: domains.IExternalSystemDataMapping;
        externalSystemDataMappings: domains.IExternalSystemDataMapping[] = [];
        dgExternalMappings: DevExpress.ui.dxDataGridOptions;
        externalSystemType: domains.ExternalSystemType;

        mappingType: domains.ExternalMappingType;
        id: number;
        showSaveButton: boolean;

        externalMappingsChanged: any;

        static $inject = ["servicerService", "generalService"];

        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService) {
            this.loadExternalSystems();

            this.dgExternalMappings = {
                export: {
                    enabled: true,
                    fileName: "ExternalSyatemDataMappings"
                },
                bindingOptions: {
                    dataSource: "vm.externalSystemDataMappings"
                },
                paging: { pageSize: 8 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no external system data mappings",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "externalSystem.name", caption: "External System" },
                    { dataField: "externalDataFieldValue", caption: "External ID" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", cssClass: "tblOverflow", width: "60" }
                ],

            };
        }
        
        $onInit(): void {
            //console.log("INIT::CUExternalSystemDataMappingController id", this.id, this.showSaveButton);
            this.getExternalMappings();
        }

        loadExternalSystems() {
            this.generalService.getExternalSystemsByType(this.externalSystemType).then(data => {
                //console.log(data.data);
                this.externalSystems = data.data;
            });
        }
        
        getExternalMappings() {
            //console.log("id", this.id);
            if (this.id && this.id > 0)
                this.servicerService.getExternalSystemDataMapping(this.id, this.mappingType).then(data => {
                    //console.log("external systrem data mapping", data.data);
                    this.externalSystemDataMappings = data.data;
                });
        }

        addExternalMapping() {
            var esdmTemp = this.externalSystemDataMappings.filter(p => p.externalSystemId == this.externalSystem.id);
            if (esdmTemp.length > 0) {
                toastr.warning("External system data mapping with selected external system is already added");
            } else {
                var obj: domains.IExternalSystemDataMapping = {
                    id: 0,
                    mappingType : this.mappingType,
                    externalSystemId : this.externalSystem.id,
                    advisorOpDataFieldId : this.id,
                    externalSystem: this.externalSystem,
                    externalDataFieldValue :this.externalSystemDataMapping.externalDataFieldValue,
                    advisorOpDataFieldString : ""
                }

                this.externalSystemDataMappings.push(obj);
                this.clearExternalSystemDataMapping();

                this.externalMappingsChanged({ data: this.externalSystemDataMappings });
            }
        }

        clearExternalSystemDataMapping() {
            this.externalSystemDataMapping.id = 0;
            this.externalSystemDataMapping.externalDataFieldValue = "";
            this.externalSystemDataMapping.externalSystemId = null;
            this.externalSystemDataMapping.externalSystem = null;
            this.externalSystemDataMapping.mappingType = this.mappingType;
            this.externalSystem = null;

        }

        deleteExternalMapping(data: domains.IExternalSystemDataMapping) {
            //console.log(data);
            if (data.id > 0)
            {
                this.servicerService.deleteExternalSystemDataMapping(data.id).then(p => {
                    toastr.success("Successfully removed external system data mapping");
                }).catch(err => {
                    toastr.error("External system could not be removed. Error " + err.status + ": " + err.data);
                    return;
                });
            }

            var ind = this.externalSystemDataMappings.indexOf(data);
            if (ind >= 0) {
                this.externalSystemDataMappings.splice(ind, 1);

                this.externalMappingsChanged({ data: this.externalSystemDataMappings });
            }
        }

        saveExternalMapping() {
            if (this.externalSystemDataMappings.length > 0) {                
                this.servicerService.createUpdateExternalSystemDataMappings(this.externalSystemDataMappings).then(data => {
                    toastr.success("Successfully saved external system data mappings");
                    this.loadExternalSystems();
                }).catch(err => {
                    toastr.error("External systems could not be saved. Error " + err.status + ": " + err.data);
                });
            }
        }
        
    }

    class CUExternalSystemDataMapping implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                id: "<",
                mappingType: "<",
                externalMappingsChanged: "&",
                showSaveButton: "<",
                externalSystemType: "<"
            };
            this.controller = CUExternalSystemDataMappingController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/cu-external-system-data-mapping.html";
        }
    }
    angular.module(Constants.APP).component("cuExternalSystemDataMapping", new CUExternalSystemDataMapping());
}